import { CommonModule, formatDate } from "@angular/common";
import { Component, EventEmitter, Input, OnChanges, OnDestroy, OnInit, Output, SimpleChanges } from '@angular/core';
import { ReactiveFormsModule, FormsModule, FormGroup, UntypedFormArray, UntypedFormBuilder, UntypedFormGroup } from '@angular/forms';
import { ActivatedRoute } from "@angular/router";
import { NgbModalOptions } from "@ng-bootstrap/ng-bootstrap";
import { ModalOptions } from "ngx-bootstrap/modal";
import { BehaviorSubject, firstValueFrom, Subscription } from 'rxjs';
import { AppSettings } from 'src/app/services/AppSettings';
import { GigsumoConstants, USER_TYPE } from "src/app/services/GigsumoConstants";
import { TourService } from "src/app/services/TourService";
import { ApiService } from 'src/app/services/api.service';
import { CommonValues } from 'src/app/services/commonValues';
import { GigsumoService } from "src/app/services/gigsumoService";
import { JobService, updateStatusCheckBox } from "src/app/services/job.service";
import { JobModel } from 'src/app/services/jobModel';
import { UtilService } from 'src/app/services/util.service';
import { Callback } from "src/shared/interfaces/Callback";
import { CommunicationService } from "src/shared/services/CommunicationService";
import { CommonSkeletonComponent } from '../../../skeleton/common-skeleton/common-skeleton.component';
import { MatMenuModule } from '@angular/material/menu';
import { JoyrideModule } from 'ngx-joyride';
import { NG_ICON_DIRECTIVES } from '@ng-icons/core';


@Component({
  selector: 'app-job-filter-template',
  standalone: true,
  imports: [CommonModule, ReactiveFormsModule, FormsModule, CommonSkeletonComponent,
MatMenuModule, JoyrideModule,
    NG_ICON_DIRECTIVES,
  ],
  templateUrl: './job-filter-template.component.html',
  styleUrls: ['./job-filter-template.component.scss']
})
export class JobFilterTemplateComponent implements OnInit, OnChanges,Callback , OnDestroy  {
  @Input() viewType: any;
  @Input() designVersion: string = 'v2';
  @Input() filterChanges: any;
  @Input('resetFilter') clearFilter: boolean;
  @Input() businessId: string = "";
  @Input('loading') isLoading : boolean = false;
  ischeckedStatusAll: boolean = false
  totalCount
  validTotalPoints: boolean
  deactivatedJobs: Array<JobModel> = [];
  filterApplied: boolean = false
  searchContent: any;
  keyarrayjobsouces = JobService.FILTER_ELEMENT;

  keyarrayClientType = ["directHire", "systemsIntegrator", "staffingAgency", "primeVendor"];
  keysarrWorks = ["All", "Onsite", "Remote", "Hybrid"];
  userType: any = localStorage.getItem('userType')
  userIdStorage = localStorage.getItem('userId')
  jobFoundStatus: any = "Fetching Jobs..."
  activeStatus: boolean = null;
  ischeckedJobClassification: boolean = false
  ischeckedJobClassificationAll: boolean = false
  listingCount = 0;
  jobSource: any = [];
  value: number = 0;
  filterData: any;
  networkflag: boolean = false;
  jobSourceSelectNetRoute: any
  searchUserType: any
  totalmsgcounts: any;
  totalmsgcount: Subscription;
  ScreenLoadBool: boolean = false
  jobSourceSearchRoute = null
  queryParamValues: any;
  highValue: number = 0;
  options: any = {
    ceil: 20,
    floor: 0
  };
  data: any = {
    limit: 10,
    searchAfterKey: null,
    userId: localStorage.getItem('userId')
  }


  value1: number = 0;
  highValue1: number = 0;
  options1: any = {
    floor: 0,
    ceil: 99
  };
  obj: any = {
    limit: 10,
    searchAfterKey: null,
    jobPostedBy: localStorage.getItem('userId')
  }
  jobFilterForm: UntypedFormGroup;
  stopscrollFlag: boolean = false
  owner: boolean = false
  data1: any = {}
  connectionJobs: boolean = false;
  previousSearchAfterKey = null;
  ischeckedStatus: boolean = false
  previousSearchAfterKey1 = null;
  clientTypeCheckboxes = [
    { label: 'All', selected: false, disable: false },
    // { label: 'Direct Client', selected: false, disable: false },
    { label: 'Client', selected: false, disable: false },
    // { label: 'Direct Hire', selected: false, disable: false },
    { label: 'Systems Integrator', selected: false, disable: false },
    { label: 'Staffing Agency', selected: false, disable: false },
    { label: 'Prime Vendor', selected: false, disable: false },
    // { label: 'Vendor', selected: false, disable: false },
    // { label: 'Supplier', selected: false, disable: false },
  ];
  publishedPayload = {
    memberNetworkChosen : false,
    personalNetworks : [],
    users : [],
    type:"JOB",
    userId : null ,
    searchContent: null,
    searchAfterKey : null,
    limit : 10
  }
  customerPayload= {
    businessId: null,
    userId: null,
    memberNetworkChosen : false,
    businessNetworkChosen : false,
    businessNetworks: [],
    businessList: [],
    searchContent:null,
    searchAfterKey : null,
    limit: 10
  };
  publishedByStopScroll: boolean = false;
  customersStopScroll: boolean = false;
  publishedByPrevSearchAfterKey: any;
  customersPrevSearchAfterKey: any;
  showNetworkFilter  : boolean= false
  tempBusinessNetworks: any[];
  istempBusinessNetwork: boolean = false;
  statusCheckboxes = [
    { label: 'All', selected: false, disable: false },
    { label: 'Draft', selected: false, disable: false },
    { label: 'Active', selected: true, disable: false },
    { label: 'On Hold', selected: false, disable: false },
    { label: 'Filled', selected: false, disable: false },
  ];
  workModeCheckboxes: Array<{ label: string, selected: boolean, disable: boolean }> = [
    { label: 'All', selected: false, disable: false },
    { label: 'Onsite', selected: false, disable: false },
    { label: 'Remote', selected: false, disable: false },
    { label: 'Hybrid', selected: false, disable: false },
  ];

  jobclasscificationCheckboxes = [
    { label: 'All', selected: false, disable: false },
    { label: 'Corp To Corp', selected: false, disable: false },
    { label: 'W2 - Contract', selected: false, disable: false },
    { label: 'W2 - Full Time', selected: false, disable: false },
    { label: 'Part Time', selected: false, disable: false },
    { label: 'Freelance', selected: false, disable: false },
    { label: 'Internship', selected: false, disable: false },
    { label: 'Contract to Hire', selected: false, disable: false },
    { label: 'Direct Hire', selected: false, disable: false },
    { label: 'Other', selected: false, disable: false },
  ];
  filterOn: boolean = false
  response: any = [];
  ischeckedClientType: boolean = false
  ischeckedClientTypeAll: boolean = false
  triggerapi = new BehaviorSubject("null")
  getResume: boolean = false
  creditexpiredflag: boolean = false
  availablePoints
  sendProfileData
  receiveFilterData: Subscription;
  resetFilter: Subscription;
  isMyJobsShowedOnLoad: boolean = false;
  @Input() jobFilterData: any;
  isEnabled: boolean=false;
  personalNetworks: any;
  filterFormData: any;
  businessNetworkData: any;
  publishedByCount: number = 0;
  customerCount: number = 0;
  busienssNetworkCount: number = 0;
  selectedNetworkId: any;
  isDefaultNetwork: boolean = false;
  membershipType = localStorage.getItem('MemberShipType');


  constructor(private formBuilder: UntypedFormBuilder,private util: UtilService, private apiService: ApiService, private gigsumoService : GigsumoService,
    private jobService: JobService, private commonvalues: CommonValues,  private tourService:TourService,
    private activatedRoute: ActivatedRoute, private communicationService: CommunicationService) {
    this.publishedPayload.userId = localStorage.getItem('userId');
    this.createjobFilterForm();
    this.getJobSourceData();
    this.userType = localStorage.getItem('userType')
    this.receiveFilterData = this.jobService.getDataForFilter().subscribe(data => {
      if (data) {
        this.removeEntity(data.value, data.index);
      }
    })

    this.commonvalues.currentData.subscribe(data => {
      this.isEnabled = data;
    });

    this.tourService.getTourSteps('JobPage').subscribe(data => {
      this.tourSteps = data;
   });

   this.activatedRoute.queryParams.subscribe((res) => {

        if(res.isDefaultNetwork === 'true'){
            this.isDefaultNetwork = true;
            if (res.networkName === 'RECRUITER_NETWORK') {
              this.selectedNetworkId = "recruiterNetworkJobs"
            } else if (res.networkName === 'MANAGEMENT_TALENT_ACQUISITION_NETWORK') {
              this.selectedNetworkId = "mtaNetworkJobs"
            } else if (res.networkName === 'FREELANCE_RECRUITER_NETWORK') {
              this.selectedNetworkId = "freeLancerNetworkJobs"
            }
        }
        else{
          this.selectedNetworkId = res.networkId;
        }
   });


  }

  ngOnDestroy(): void {
  }

   tourSteps: any[] = [];
  getTitle(stepId: string): string {
    const step = this.tourSteps.find(s => s.stepId === stepId);
    return step ? step.title : 'Loading...';
  }

  getText(stepId: string): string {
    const step = this.tourSteps.find(s => s.stepId === stepId);
    return step ? step.text : 'Loading...';
  }

   executeMethod(data: string): void {
    this.sourceCount= 0;
    this.clientTypeCount= 0;
    this.engagementTypeCount=0;
    this.statusCount= 0;
    this.postedByCount= 0;
  }

  sourceCount: number = 0;
  clientTypeCount: number = 0;
  engagementTypeCount: number = 0;
  statusCount: number = 0;
  postedByCount: number = 0;
  workTypeCount : number = 0;
  memberShipType = localStorage.getItem('MemberShipType');

 // recieve filter data from new-job component

 // recieve filter data from new-job component
 ngOnChanges(changes: SimpleChanges) {

    this.customerPayload.userId = localStorage.getItem('userId');
    this.updateJobFilterData();

    if (changes.filterChanges !== undefined && changes.filterChanges.currentValue != undefined) {

      let data: any = changes.filterChanges.currentValue;

      // fetching the total counts of the source for numbering the filter elements
      // fetching filter number starts here

      if(data.formData.source && data.formData.source.length > 0){
        this.sourceCount = this.computeSourceCount(data.formData.source[0]);
      }

      //clientType count starts here
      const keyValuePairs1: Record<string, boolean> = {};
      data.clientTypeCheckedItems.forEach(item => {
        if(item.label != 'All'){
          keyValuePairs1[item.label] = item.selected;
        }
      });

      const keyCounts1 = Object.values(keyValuePairs1).reduce((count, item) => {
        return count + (item ? 1 : 0);
      }, 0);

      this.clientTypeCount = keyCounts1;
      //clientType count ends here

      // jobclassification / engagement type count starts here
      const keyValuePairs2: Record<string, boolean> = {};
      data.jobClassifications.forEach(item => {
        if(item.label != 'All'){
          keyValuePairs2[item.label] = item.selected;
        }
      });

      const keyCounts2 = Object.values(keyValuePairs2).reduce((count, item) => {
        return count + (item ? 1 : 0);
      }, 0);

      this.engagementTypeCount = keyCounts2;
      // jobclassification / engagement type count ends here

      console.log(this.statusCheckboxes , data.statusCheckboxes);

      // status count starts here
      const keyValuePairs3: Record<string, boolean> = {};
      data.statusCheckedItems.forEach(item => {
        if(item.label != 'All' && !item.disable){
          keyValuePairs3[item.label] = item.selected;
        }
      });



      const keyCounts3 = Object.values(keyValuePairs3).reduce((count, item) => {
        return count + (item ? 1 : 0);
      }, 0);

      this.statusCount = keyCounts3;
      // status count ends here

      let trueCount = 0;
      const data1 = data.formData.organisationTypeParams;
      for (const key in data1) {
        if (Object.prototype.hasOwnProperty.call(data1, key) && data1[key] === true) {
          trueCount++;
        }
      }
      this.postedByCount = trueCount;

      if(data.workMode && data.workMode.length > 0){
        this.workTypeCount = data.workMode.filter(x => x.label != 'All').reduce((acc, curr) =>{
          return acc + (curr.selected ? 1 : 0);
        }, 0);
      }

      if(data.formData.resetFilter === true){
        this.resetFilterDefault();
      }

      this.filterFormData = data.formData;
      this.jobFilterForm.patchValue(this.filterFormData);
      this.jobSource = data.checkedItems;
      this.clientTypeCheckboxes = data.clientTypeCheckedItems;
      this.statusCheckboxes = data.statusCheckedItems;
      this.workModeCheckboxes = data.workMode;
      this.jobclasscificationCheckboxes = data.jobClassifications;
      this.value1 = data.formData.postedFrom != null ? data.formData.postedFrom : 0;
      this.highValue1 = data.formData.postedTo != null ? data.formData.postedTo : 0;

      let customerSelected = data.customerSelectedData === undefined ? [] : data.customerSelectedData;
      let publishedSelected = data.publishedSelectedData === undefined ? [] : data.publishedSelectedData;

      const isMyJobsChecked : boolean  =  data.formData.source[0].myJobs;
      this.statusCheckboxes = updateStatusCheckBox(data.statusCheckedItems , (this.owner ? isMyJobsChecked : false), false);

      // since we removed the publishedBy , customer and business Network the below code is not needed
      // for future use may be commenting this - prasanna

      // busniess network interaction
      // if(data.formData.source[0].businessNetwork != this.istempBusinessNetwork ||
      //   JSON.stringify(data.businessNetworks) != JSON.stringify(this.customerPayload.businessNetworks) ||
      //   JSON.stringify(this.customerPrevSelectedValue) != JSON.stringify(data.customerSelectedData)){
        //   this.setToDefaulFilter("CUSTOMER");
      //   this.istempBusinessNetwork = data.formData.source[0].businessNetwork;
      //   this.customerPayload.businessNetworks = data.businessNetworks === undefined ? [] : data.businessNetworks;
      //   this.customerPayload.businessList = customerSelected.map(x=>x.businessId);
      //   this.getBusinessCustomers();
      // }

      // member and personal network interaction
      // if(data.formData.source[0].memberNetworksJobs != this.publishedPayload.memberNetworkChosen ||
      //   JSON.stringify(data.personalNetworks) != JSON.stringify(this.publishedPayload.personalNetworks) ||
      //   JSON.stringify(this.publishedByPrevSelectedValue) != JSON.stringify(data.publishedSelectedData)){
      //   this.setToDefaulFilter();
      //   this.publishedPayload.memberNetworkChosen = data.formData.source[0].memberNetworksJobs;
      //   this.publishedPayload.personalNetworks = data.personalNetworks === undefined ? [] : data.personalNetworks;
      //   this.publishedPayload.users = publishedSelected.map(x=>x.userId);
      //   this.getPublishedBy();
      // }

      // this.businessNetworkPrevSelectedValue =  data.businessNetworkSelectedData === undefined ? [] : data.businessNetworkSelectedData;
      this.customerPrevSelectedValue = customerSelected;
      this.publishedByPrevSelectedValue =  publishedSelected;
      this.selectedPublishedBy = data.publishedByUsers === undefined ? [] : data.publishedByUsers;
      this.selectedCustomers = data.businessCustomers === undefined ? [] : data.businessCustomers;

      // this.customerCount = this.customerPrevSelectedValue != undefined ? this.customerPrevSelectedValue.length : 0;
      // this.publishedByCount = this.publishedByPrevSelectedValue != undefined ? this.publishedByPrevSelectedValue.length : 0;

      // this.selectedBusinessNetworks = data.businessNetworks === undefined ? [] : data.businessNetworks;


      // if(this.businessNetworkPrevSelectedValue.length > 0){
      //   setTimeout(() => {
      //     this.businessNetworkData = this.businessNetworkPrevSelectedValue;
      //     this.busienssNetworkCount = this.businessNetworkPrevSelectedValue != undefined ? this.businessNetworkPrevSelectedValue.filter(x => x.enabled).length : 0;
      //    }, 1000);
      // }


    }
  }

  resetFilterDefault(){
    this.jobsouceCheckedAll(false);
    this.publishedPayload.personalNetworks = [];
    this.customerPayload.businessNetworks = [];
    this.publishedPayload.searchContent = "";
    this.customerPayload.searchContent = "";
    this.selectedBusinessNetworks = [];
    this.selectedPublishedBy = [];
    this.selectedCustomers = [];
    this.businessNetworkData =  this.tempBusinessNetworks;
    this.customerPrevSelectedValue = [];
    this.publishedByPrevSelectedValue = [];
    this.businessNetworkPrevSelectedValue = [];
    this.setToDefaulFilter();
    this.setToDefaulFilter("CUSTOMER");
    this.getPublishedBy();
    this.getBusinessCustomers();
}



  showChevron: boolean = false;
  showChevron1: boolean = false;
  onMouseEnter() {
    this.showChevron = true;
  }

  onMouseLeave() {
    this.showChevron = false;
  }

  onMouseEnter1() {
    this.showChevron1 = true;
  }

  onMouseLeave1() {
    this.showChevron1 = false;
  }

  scrollLeft() {
    const scrollContainer = document.getElementById('scrollContainer');
    if (scrollContainer) {
      scrollContainer.scrollBy({ left: -280, behavior: 'smooth' });
    }
  }

  scrollRight() {
    const scrollContainer = document.getElementById('scrollContainer');
    if (scrollContainer) {
      scrollContainer.scrollBy({ left: 280, behavior: 'smooth' });
    }
  }

  subscribe: Subscription
  // counter: number = 0


  // @ViewChild('jobSource', { static: false }) jobSource1: ElementRef;
  // @ViewChild('engagementType', { static: false }) engagementType1: ElementRef;
  // @ViewChild('status', { static: false }) status1: ElementRef;
  // @ViewChild('postedDayRange', { static: false }) postedDayRange1: ElementRef;
  // @ViewChild('experienceType', { static: false }) experienceType1: ElementRef;
  // @ViewChild('organisationTypeParams', { static: false }) organisationTypeParams: ElementRef;
  // calculateInputWidth(value): number {
  //   const text = this.FilterForm.get(value).value;
  //   const spanElement = document.createElement('span');
  //   spanElement.style.visibility = 'hidden';
  //   spanElement.style.position = 'absolute';
  //   spanElement.style.whiteSpace = 'nowrap';
  //   spanElement.innerText = text;
  //   document.body.appendChild(spanElement);
  //   const width = spanElement.offsetWidth;
  //   document.body.removeChild(spanElement);
  //   console.log(value + width + "this is the width everyone")
  //   return width;
  //   // if (value == 'jobSource' && this.jobSource1) {
  //   //   // const inputElement = this.jobSource1.nativeElement;
  //   // }
  //   // if (value == 'engagementType' && this.engagementType1) {
  //   //   const textWidthMeasurer = this.engagementType1.nativeElement;
  //   //   textWidthMeasurer.innerText = this.FilterForm.get(value).value;
  //   //   console.log(textWidthMeasurer.offsetWidth + "engagementtextWidthMeasurer.offsetWidth")
  //   //   return textWidthMeasurer.offsetWidth;
  //   // }
  //   // if (value == 'status' && this.status1) {
  //   //   const textWidthMeasurer = this.status1.nativeElement;
  //   //   textWidthMeasurer.innerText = this.FilterForm.get(value).value;
  //   //   return textWidthMeasurer.offsetWidth;
  //   // }
  //   // if (value == 'postedDayRange' && this.postedDayRange1) {
  //   //   const textWidthMeasurer = this.postedDayRange1.nativeElement;
  //   //   textWidthMeasurer.innerText = this.FilterForm.get(value).value;
  //   //   return textWidthMeasurer.offsetWidth;
  //   // }
  //   // if (value == 'experienceType' && this.experienceType1) {
  //   //   const textWidthMeasurer = this.experienceType1.nativeElement;
  //   //   textWidthMeasurer.innerText = this.FilterForm.get(value).value;
  //   //   return textWidthMeasurer.offsetWidth;
  //   // }
  //   // if (value == 'organisationTypeParams' && this.organisationTypeParams) {
  //   //   const textWidthMeasurer = this.organisationTypeParams.nativeElement;
  //   //   textWidthMeasurer.innerText = this.FilterForm.get(value).value;
  //   //   return textWidthMeasurer.offsetWidth;
  //   // }

  // }

  @Input() valuesSentForFilters: any;
  lablechangeclienttype: string = '';

  ngOnInit() {
    this.communicationService.setCallback(this);

  }

  getJobSourceData() {

    // this.gigsumoService.getFilterELement("JOB" , this.userIdStorage).subscribe(response=>{

    // })
    this.gigsumoService.getFilterELement("JOB" , this.userIdStorage).subscribe(response=>{
        if(response.code === GigsumoConstants.SUCESSCODE){
          this.businessNetworkData =  response.data.businessNetworks;
          this.tempBusinessNetworks = this.businessNetworkData;
          this.personalNetworks = response.data.personalNetworks.map(r=>{
            let data = GigsumoService.FILTER_ITEMS().find(x => x.value === r.networkName);
            if(data){
              r.key = data.key;
            }
            else{
              r.key = r.networkId;
            }
            return r;
          });
          this.jobsoucefilterFrom(this.personalNetworks);
        }
    });

  }

  updateJobFilterData() {

    const userType = localStorage.getItem('userType') as USER_TYPE;

    if (this.isMTAorFREEandREC(userType)) {
      this.owner = true;
    }
    else {
      this.owner = false;
    }

  }

  isBenchOrJob(userType: USER_TYPE): boolean {
    return (userType === GigsumoConstants.BENCH_RECRUITER || userType === GigsumoConstants.JOB_SEEKER);
  }

  isRecruiter(userType: USER_TYPE): boolean {
    return (userType === GigsumoConstants.RECRUITER);
  }

  isMTAorFREEandREC(userType: USER_TYPE): boolean {
    return (userType === GigsumoConstants.MANAGEMENT_TALENT_ACQUISITION
      || userType === GigsumoConstants.FREELANCE_RECRUITER || userType === GigsumoConstants.RECRUITER);
  }

  isMTAorFREE(userType: USER_TYPE): boolean {
    return (userType === GigsumoConstants.MANAGEMENT_TALENT_ACQUISITION || userType === GigsumoConstants.FREELANCE_RECRUITER);
  }

  settingUpFilters() {
    if (!this.isMyJobsShowedOnLoad && this.networkflag == false && !this.queryParamValues.networkflag
      && this.jobSourceSearchRoute == null) {
      this.jobSource.push('marketPlaceJobs')
      this.jobSource = [...new Set(this.jobSource)]
      this.data1.searchAfterKey = null;
      ((this.jobFilterForm.get('source') as UntypedFormArray).at(0) as UntypedFormGroup).get('marketPlaceJobs').patchValue(true);

    } else if (this.owner && this.isMyJobsShowedOnLoad && this.networkflag == false && !this.queryParamValues.networkflag
      && this.jobSourceSearchRoute == null) {
      this.jobSource.push('myJobs')
      this.jobSource = [...new Set(this.jobSource)]
      this.data1.searchAfterKey = null;
      ((this.jobFilterForm.get('source') as UntypedFormArray).at(0) as UntypedFormGroup).get('myJobs').patchValue(true);

    } else if (this.networkflag == true && this.queryParamValues.networkflag) {
      this.jobSource.push(this.jobSourceSelectNetRoute)
      this.jobSource = [...new Set(this.jobSource)]
      this.data1.searchAfterKey = null;
      ((this.jobFilterForm.get('source') as UntypedFormArray).at(0) as UntypedFormGroup).get(this.jobSourceSelectNetRoute).patchValue(true);

    } else if (this.jobSourceSearchRoute != null) {
      this.jobSource = []
      this.jobSource.push(this.jobSourceSearchRoute)
      this.jobSource = [...new Set(this.jobSource)]
      this.data1.searchAfterKey = null;
      ((this.jobFilterForm.get('source') as UntypedFormArray).at(0) as UntypedFormGroup).patchValue({
        all: false,
        myJobs: false,
        marketPlaceJobs: false,
        teamJobs: false,
        recruiterNetworkJobs: false,
        freeLancerNetworkJobs: false,
        mtaNetworkJobs: false,
        featured: false,
        suggestedJobs: false,
        eligibleSubContractJobs: false,
      });
      ((this.jobFilterForm.get('source') as UntypedFormArray).at(0) as UntypedFormGroup).get(this.jobSourceSearchRoute).patchValue(true);

    }
  }

  listingDeactivatedJobs() {
    var userid = localStorage.getItem('userId');
    var userType = localStorage.getItem('userType');
    let profiledata: any = {}
    profiledata.userId = userid;
    profiledata.userType = userType;
    const format = 'dd-MM-yyyy';
    const locale = 'en-US';
    let lastLoggedTime: any = localStorage.getItem('lastLogged');

    if (lastLoggedTime != null && lastLoggedTime != undefined) {

      let datas: any = {}

      this.apiService.create('user/profileDetails', profiledata).subscribe(profileres => {
        let logged = new Date(lastLoggedTime);
        let today = new Date();

        const lastloggedYesterday = this.dateInPast(logged);
        if (formatDate(logged, format, locale) < formatDate(today, format, locale) || lastloggedYesterday) {
          if (profileres != undefined && profileres.code === "00000") {
            this.sendProfileData = profileres;

            this.availablePoints = profileres.data.creditPoints;



            this.apiService.query('jobs/listingDeactivatedJobsandCandidates/' + userid + "/" + userType).subscribe(res => {

              if (res.code === "00000" && res.data.deactivatedJobs != undefined) {

                this.deactivatedJobs = res.data.deactivatedJobs;
                this.totalCount = this.deactivatedJobs.length;

                let totalcredit = profileres.data.creditPoints;
                let sum = 0;
                this.deactivatedJobs.forEach(element => {

                  element.isSelected = false;

                  if (element.isFeatured == true) {
                    datas = profileres.data.creditConsumptions.find(item => item.creditType === AppSettings.UPGRADED_JOB);
                    sum = sum + datas.points;
                    element.points = datas.points
                    element.consumptionType = datas.creditType;
                  }
                  else {
                    datas = profileres.data.creditConsumptions.find(item => item.creditType === AppSettings.CREATE_JOB);
                    sum = sum + datas.points;
                    element.points = datas.points;
                    element.consumptionType = datas.creditType;
                  }
                });
                this.deactivatedJobs[0].totalpoints = sum;
                if (sum < totalcredit) {
                  this.validTotalPoints = true;
                }
                else {
                  this.validTotalPoints = false;
                }

                //validating popup to appear only one day

                let ngbModalOptions: NgbModalOptions = { backdrop: 'static', keyboard: false };
                let checkModalOpenedToday: any = localStorage.getItem(userid + '_jobmodalOpened');

                if (checkModalOpenedToday != null || checkModalOpenedToday != undefined) {

                  const openedDate = new Date(checkModalOpenedToday.toString());

                  // openedDate.valueOf() < endofDay;
                  const checkDateIfYesterDay = this.dateInPast(openedDate);

                  if (checkDateIfYesterDay) {
                    this.listingCount = 0;
                    localStorage.removeItem(userid + '_jobmodalOpened')
                  }
                  else if (!checkDateIfYesterDay) {
                    this.listingCount++;
                  }
                }

                if (this.listingCount >= 1) {
                  return;
                }
                const config: ModalOptions = { class: 'modal-lg', backdrop: 'static', keyboard: false };
                //this.modalRef = this.modalService.show(this.listingmodal, config);
                setTimeout(() => {
                  localStorage.setItem(userid + '_jobmodalOpened', String(today));
                }, 1000);
                // $('body').css('position','fixed').css('overflow', 'hidden');
                this.stopscrollFlag = true;

              }

            });

          }
        }
      });


    }

  }

  dateInPast(date) {
    const today = new Date();
    today.setHours(0, 0, 0, 0);
    return date < today;
  }

  onLoad() {
    let data: any = JSON.parse(localStorage.getItem('jobForm'));
    for (let key in data.source) {
      if (data.source[key] === true) {
        ((this.jobFilterForm.get('source') as UntypedFormArray).at(0) as UntypedFormGroup).get(key).patchValue(true);
        this.jobSource.push(key)
        this.jobSource.forEach((ele, index) => {
          if (this.FeaSugg && ele === "featured" || this.FeaSugg && ele === "suggestedJobs") {
            this.jobSource.splice(index, 1)
          }
          if (!this.owner && ele === "myJobs") {
            this.jobSource.splice(index, 1)
          }
        })
      }
    }
    data.clientType.forEach((res) => {
      this.clientTypeCheckboxes.forEach(item => {
        if (item.label === res) {
          item.selected = true;
          this.jobSource.push(res)
        }
      });
    });
    data.status.forEach((res) => {
      this.statusCheckboxes.forEach(item => {
        if (item.label === res) {
          item.selected = true;
          this.jobSource.push(res)
        }
      });
    });
    data.jobClassification.forEach((res) => {
      this.jobclasscificationCheckboxes.forEach(item => {
        if (item.label === res) {
          item.selected = true;
          this.jobSource.push(res)
        }
      });
    });
    for (let key in data.workType) {
      if (data.workType[key] === true) {
        ((this.jobFilterForm.get('workType') as UntypedFormArray).at(0) as UntypedFormGroup).get(key).patchValue(true);
        this.jobSource.push(key)
      }
    }

    this.jobSource = [...new Set(this.jobSource)]
    this.jobSource.forEach((ele, index) => {
      if (ele === "All" || ele === "all") {
        this.jobSource.splice(index, 1)
      }
    })
    this.value = data.experienceFrom != null ? data.experienceFrom : 0;
    this.highValue = data.experienceTo != null ? data.experienceTo : 0;
    this.value1 = data.postedFrom != null ? data.postedFrom : 0;
    this.highValue1 = data.postedTo != null ? data.postedTo : 0;


    this.jobFilterForm.get('country').patchValue(data.country)
    this.jobFilterForm.get('state').patchValue(data.state)
    this.jobFilterForm.get('city').patchValue(data.city)
    this.jobFilterForm.get('zipCode').patchValue(data.zipCode)

    localStorage.setItem('jobSource', this.jobSource);
  }

  get jobSourcesFormarray() {
    return this.jobFilterForm.get('source') as UntypedFormArray;
  }

  // Single source of truth for the Job Source badge count. Counts the `true`
  // flags in the source group, excluding the "all" toggle and the entries that
  // aren't real user picks for the current role/plan (bench-recruiter "myJobs",
  // Free/Pro "businessNetwork"). Called both from ngOnChanges (parent-driven
  // refresh) AND from jobSoucecheck (live in-dropdown toggles) so the badge
  // stays in sync with the checkboxes instead of going stale — the count used
  // to update only on the input round-trip, which never fired on a toggle.
  private computeSourceCount(source0: Record<string, boolean>): number {
    if (!source0) {
      return 0;
    }
    const userType = localStorage.getItem('userType');
    return Object.keys(source0).reduce((count, value) => {
      if (userType === GigsumoConstants.BENCH_RECRUITER && value === 'myJobs') {
        return count;
      }
      if ((this.memberShipType === 'Free' || this.memberShipType === 'Pro') && value === 'businessNetwork') {
        return count;
      }
      // Sub-Contracting checkbox is hidden for Job Seekers and Free plans
      // (same condition as its *ngIf), but the All toggle still patches it true.
      if (value === 'eligibleSubContractJobs'
        && (userType === GigsumoConstants.JOB_SEEKER || this.memberShipType === 'Free')) {
        return count;
      }
      // 'myEmployees' has no checkbox in this dropdown (SuperAdmin org view only),
      // but the All toggle still patches it true → never count it here.
      if (value === 'all' || value === 'myEmployees') {
        return count;
      }
      return count + (source0[value] ? 1 : 0);
    }, 0);
  }

  // @Output() clientTypeChecked = new EventEmitter<any>();
  clientTypecheck(event, lable, param?: any) {
    this.response = []
    this.obj.searchAfterKey = null;
    this.data1.searchAfterKey = null;
    this.previousSearchAfterKey = null;
    this.previousSearchAfterKey1 = null;
    this.stopscrollFlag = false;
    let allData = [];
    this.clientTypeCheckboxes.forEach(item => {
      if (item.label == lable) {
        item.selected = event.target.checked;
      }
      if(item.label != 'All'){
        allData.push(item);
      }
    });

    this.response = []
    this.data1.searchAfterKey = null;
    if (event.target.checked == true) {
      this.ischeckedClientType = true;

      if (lable == 'All') {
        for (let key of this.clientTypeCheckboxes) {
          if (key.label != 'All') {
            this.jobSource.push(key.label);
            this.jobSource = [...new Set(this.jobSource)]
          }
        }
        this.clientTypeCheckedAll(event);
      } else {
        this.jobSource.push(lable);
        this.jobSource = [...new Set(this.jobSource)]
      }

      if(allData.every(x => x.selected === true)){
        this.clientTypeCheckboxes[0].selected = true;
      }

    }
    else if (event.target.checked == false) {
      if (lable != 'All') {
        this.clientTypeCheckboxes[0].selected = false;
        if (this.jobSource.includes(lable)) {
          this.jobSource.splice(this.jobSource.indexOf(lable), 1);
        }

      }

      if (lable == 'All') {
        for (let key of this.clientTypeCheckboxes) {
          if (this.jobSource.includes(key.label) && key.label != 'All') {
            this.jobSource.splice(this.jobSource.indexOf(key.label), 1);
            this.jobSource = [...new Set(this.jobSource)]
          }
        }
        this.clientTypeCheckedAll(event);
      }
      // this.clientTypeChecked.emit({event, lable, par   am});
    }

    if (this.ischeckedClientType && this.ischeckedClientTypeAll) {
      event.target.checked = true
    }
    // this.filterWhenNoneJobSouce();
    // this.cdr.detectChanges();
    this.updateFunction()
  }

  // used to sent filter data to parent new-job Component on every click
  updateFunction(content = "HORIZANTAL") {

    let personalNetworkData = [];
    if(this.jobSource){
      this.jobSource.forEach(element => {
        this.personalNetworks.forEach(x=>{
            if(x.key === element){
              personalNetworkData.push(x.networkId);
            }
        });
      });
    }
    const isBusinessNetwork = this.jobSourcesFormarray.at(0)!=undefined && this.jobSourcesFormarray.at(0).get('businessNetwork').value;

    this.jobFilterForm.get('resetFilter').patchValue(false);

    if (this.jobFilterData) {
      this.jobFilterData.clickHandler.apply(this.jobFilterData.source,
        [{
          formData: this.jobFilterForm.getRawValue(),
          checkedItems: this.jobSource,
          jobClassifications: this.jobclasscificationCheckboxes,
          statusCheckedItems: this.statusCheckboxes,
          clientTypeCheckedItems: this.clientTypeCheckboxes,
          personalNetworks : personalNetworkData,
          // Match the vertical filter's behaviour (job-filter-vertical-template :1126):
          // send the user's actual network pick when they've narrowed, otherwise fall
          // back to the full list on the Business Network tab. Previously this always
          // sent every network on the tab, so a particular-network pick was discarded
          // and the horizontal filter could never narrow (vertical already worked).
          businessNetworks : (this.selectedBusinessNetworks && this.selectedBusinessNetworks.length > 0) ? this.selectedBusinessNetworks : (isBusinessNetwork ? (this.businessNetworkData!= undefined ? this.businessNetworkData.map(x => x.b2bNetworkId) : []) : []) ,
          publishedByUsers : this.selectedPublishedBy,
          businessCustomers : this.selectedCustomers,
          customerSelectedData : this.customerPrevSelectedValue,
          publishedSelectedData : this.publishedByPrevSelectedValue,
          businessNetworkSelectedData : this.businessNetworkPrevSelectedValue,
          workMode : this.workModeCheckboxes,
          from: content,
        }]);
    }
  }


  // filterWhenNoneJobSouce() {
  //   if (!this.owner) {
  //     if (((this.jobFilterForm.get('source') as UntypedFormArray).at(0) as UntypedFormGroup).get('teamJobs').value == false &&
  //       ((this.jobFilterForm.get('source') as UntypedFormArray).at(0) as UntypedFormGroup).get('recruiterNetworkJobs').value == false &&
  //       ((this.jobFilterForm.get('source') as UntypedFormArray).at(0) as UntypedFormGroup).get('freeLancerNetworkJobs').value == false &&
  //       ((this.jobFilterForm.get('source') as UntypedFormArray).at(0) as UntypedFormGroup).get('mtaNetworkJobs').value == false) {

  //       ((this.jobFilterForm.get('source') as UntypedFormArray).at(0) as UntypedFormGroup).patchValue({
  //         teamJobs: true,
  //         recruiterNetworkJobs: true,
  //         freeLancerNetworkJobs: true,
  //         mtaNetworkJobs: true,
  //         featured: true,
  //         suggestedJobs: true
  //       })


  //       this.jobSource.push("teamJobs");
  //       this.jobSource.push("recruiterNetworkJobs");
  //       this.jobSource.push("freeLancerNetworkJobs");
  //       this.jobSource.push("MTA Network");
  //       if (!this.FeaSugg) {
  //         this.jobSource.push("featured");
  //         this.jobSource.push("suggestedJobs");
  //       }

  //       this.jobSource = [...new Set(this.jobSource)]
  //     }
  //   }
  //   if (this.owner && this.isMyJobsShowedOnLoad) {
  //     if (((this.jobFilterForm.get('source') as UntypedFormArray).at(0) as UntypedFormGroup).get('myJobs').value == false &&
  //       ((this.jobFilterForm.get('source') as UntypedFormArray).at(0) as UntypedFormGroup).get('recruiterNetworkJobs').value == false &&
  //       ((this.jobFilterForm.get('source') as UntypedFormArray).at(0) as UntypedFormGroup).get('marketPlaceJobs').value == false &&
  //       ((this.jobFilterForm.get('source') as UntypedFormArray).at(0) as UntypedFormGroup).get('freeLancerNetworkJobs').value == false &&
  //       ((this.jobFilterForm.get('source') as UntypedFormArray).at(0) as UntypedFormGroup).get('mtaNetworkJobs').value == false &&
  //       ((this.jobFilterForm.get('source') as UntypedFormArray).at(0) as UntypedFormGroup).get('teamJobs').value == false) {

  //       ((this.jobFilterForm.get('source') as UntypedFormArray).at(0) as UntypedFormGroup).get('myJobs').patchValue(true);
  //       this.jobSource.push("myJobs");
  //       this.jobSource = [...new Set(this.jobSource)]
  //     }
  //   } else if (!this.isMyJobsShowedOnLoad) {
  //     if (((this.jobFilterForm.get('source') as UntypedFormArray).at(0) as UntypedFormGroup).get('myJobs').value == false &&
  //       ((this.jobFilterForm.get('source') as UntypedFormArray).at(0) as UntypedFormGroup).get('recruiterNetworkJobs').value == false &&
  //       ((this.jobFilterForm.get('source') as UntypedFormArray).at(0) as UntypedFormGroup).get('marketPlaceJobs').value == false &&
  //       ((this.jobFilterForm.get('source') as UntypedFormArray).at(0) as UntypedFormGroup).get('freeLancerNetworkJobs').value == false &&
  //       ((this.jobFilterForm.get('source') as UntypedFormArray).at(0) as UntypedFormGroup).get('mtaNetworkJobs').value == false &&
  //       ((this.jobFilterForm.get('source') as UntypedFormArray).at(0) as UntypedFormGroup).get('teamJobs').value == false) {

  //       ((this.jobFilterForm.get('source') as UntypedFormArray).at(0) as UntypedFormGroup).get('marketPlaceJobs').patchValue(true);
  //       this.jobSource.push("marketPlaceJobs");
  //       this.jobSource = [...new Set(this.jobSource)]
  //     }
  //   }
  // }


  POSTED_ANY = GigsumoConstants.POSTED_ANY;
  POSTED_TODAY = GigsumoConstants.POSTED_TODAY;
  POSTED_LAST_7_DAYS = GigsumoConstants.POSTED_LAST_7_DAYS;
  POSTED_LAST_14_DAYS = GigsumoConstants.POSTED_LAST_14_DAYS;
  POSTED_LAST_30_DAYS = GigsumoConstants.POSTED_LAST_30_DAYS;

  POSTED_BY_ANY = GigsumoConstants.POSTED_BY_ANY;
  POSTED_BY_EMPLOYER = GigsumoConstants.POSTED_BY_EMPLOYER;
  POSTED_BY_SYSTEMS_INTEGRATOR = GigsumoConstants.POSTED_BY_SYSTEMS_INTEGRATOR;
  POSTED_BY_PRIME_VENDOR = GigsumoConstants.POSTED_BY_PRIME_VENDOR;
  POSTED_BY_VENDOR_OR_STAFFING_AGENCY = GigsumoConstants.POSTED_BY_VENDOR_OR_STAFFING_AGENCY;

  EXPERIENCE_ANY = GigsumoConstants.EXPERIENCE_ANY;
  EXPERIENCE_JUNIOR = GigsumoConstants.EXPERIENCE_JUNIOR;
  EXPERIENCE_MID_LEVEL = GigsumoConstants.EXPERIENCE_MID_LEVEL;
  EXPERIENCE_SENIOR = GigsumoConstants.EXPERIENCE_SENIOR;
  EXPERIENCE_ARCHITECT = GigsumoConstants.EXPERIENCE_ARCHITECT;

  onPostedDaysChange(content : string) {


    if (content === GigsumoConstants.POSTED_TODAY) {
      this.jobFilterForm.patchValue({ postedFrom: 1, postedTo: 1 });
    } else if (content === GigsumoConstants.POSTED_LAST_7_DAYS) {
      this.jobFilterForm.patchValue({ postedFrom: 1, postedTo: 7 });
    } else if (content === GigsumoConstants.POSTED_LAST_14_DAYS) {
      this.jobFilterForm.patchValue({ postedFrom: 1, postedTo: 14 });
    } else if (content === GigsumoConstants.POSTED_LAST_30_DAYS) {
      this.jobFilterForm.patchValue({ postedFrom: 1, postedTo: 30 });
    } else {
      this.jobFilterForm.patchValue({ postedFrom: null, postedTo: null });
    }

    this.updateFunction();
  }


  totalCountJob: number = 0;

  statuscheckbox(event, lable, param?: any) {
    this.stopscrollFlag = false
    this.response = []
    this.obj.searchAfterKey = null;
    this.data1.searchAfterKey = null;
    this.previousSearchAfterKey = null;
    this.previousSearchAfterKey1 = null;

    let allData = [];
    this.statusCheckboxes.forEach(item => {
      if (lable === 'Active') {
        this.activeStatus = true
      }
      else {
        this.activeStatus = false
      }
      if (item.label == lable) {
        item.selected = event.target.checked;
      }

      if(item.label != 'All'){
        allData.push(item);
      }
    });


    if (event.target.checked == true) {
      this.ischeckedJobClassification = true;
      if (lable == 'All') {
        for (let key of this.statusCheckboxes) {
          if (key.label != 'All' && !this.jobSource.includes(key)) {
            this.jobSource.push(key.label);
            this.jobSource = [...new Set(this.jobSource)]
          }
        }
        this.statusCheckAll(event);
      }
      else {

        this.jobSource.push(lable);
        this.jobSource = [...new Set(this.jobSource)]

      }

      if(allData.every(x => x.selected === true)){
        this.statusCheckboxes[0].selected = true;
      }

    }
    else if (event.target.checked == false) {
      if (lable != 'All') {
        this.statusCheckboxes[0].selected = false;
        if (this.jobSource.includes(lable)) {
          this.jobSource.splice(this.jobSource.indexOf(lable), 1);
        }
      }

      if (lable == 'All') {
        for (let key of this.statusCheckboxes) {
          if (this.jobSource.includes(key.label) && key.label != 'All') {
            this.jobSource.splice(this.jobSource.indexOf(key.label), 1);
            this.jobSource = [...new Set(this.jobSource)]
          }
        }
        this.statusCheckAll(event);
      }

    }

    if (this.ischeckedJobClassification && this.ischeckedJobClassificationAll) {
      event.target.checked = true
    }
    // if (this.activeStatus) {

    //   if (!this.owner) {
    //     if (((this.jobFilterForm.get('source') as UntypedFormArray).at(0) as UntypedFormGroup).get('teamJobs').value == false &&
    //       ((this.jobFilterForm.get('source') as UntypedFormArray).at(0) as UntypedFormGroup).get('recruiterNetworkJobs').value == false &&
    //       ((this.jobFilterForm.get('source') as UntypedFormArray).at(0) as UntypedFormGroup).get('freeLancerNetworkJobs').value == false &&
    //       ((this.jobFilterForm.get('source') as UntypedFormArray).at(0) as UntypedFormGroup).get('mtaNetworkJobs').value == false) {

    //       ((this.jobFilterForm.get('source') as UntypedFormArray).at(0) as UntypedFormGroup).get('teamJobs').patchValue(true);
    //       ((this.jobFilterForm.get('source') as UntypedFormArray).at(0) as UntypedFormGroup).get('recruiterNetworkJobs').patchValue(true);
    //       ((this.jobFilterForm.get('source') as UntypedFormArray).at(0) as UntypedFormGroup).get('freeLancerNetworkJobs').patchValue(true);
    //       ((this.jobFilterForm.get('source') as UntypedFormArray).at(0) as UntypedFormGroup).get('mtaNetworkJobs').patchValue(true);
    //       ((this.jobFilterForm.get('source') as UntypedFormArray).at(0) as UntypedFormGroup).get('all').patchValue(true);

    //       this.jobSource.push("teamJobs");
    //       this.jobSource.push("recruiterNetworkJobs");
    //       this.jobSource.push("freeLancerNetworkJobs");
    //       this.jobSource.push("MTA Network");
    //       if (!this.FeaSugg) {
    //         this.jobSource.push("featured");
    //         this.jobSource.push("suggestedJobs");
    //       }

    //       this.jobSource = [...new Set(this.jobSource)]
    //     }
    //   }
    //   if (this.owner) {
    //     if (((this.jobFilterForm.get('source') as UntypedFormArray).at(0) as UntypedFormGroup).get('myJobs').value == false &&
    //       ((this.jobFilterForm.get('source') as UntypedFormArray).at(0) as UntypedFormGroup).get('recruiterNetworkJobs').value == false &&
    //       ((this.jobFilterForm.get('source') as UntypedFormArray).at(0) as UntypedFormGroup).get('freeLancerNetworkJobs').value == false &&
    //       ((this.jobFilterForm.get('source') as UntypedFormArray).at(0) as UntypedFormGroup).get('mtaNetworkJobs').value == false &&
    //       ((this.jobFilterForm.get('source') as UntypedFormArray).at(0) as UntypedFormGroup).get('teamJobs').value == false) {

    //       ((this.jobFilterForm.get('source') as UntypedFormArray).at(0) as UntypedFormGroup).get('myJobs').patchValue(true);
    //       ((this.jobFilterForm.get('source') as UntypedFormArray).at(0) as UntypedFormGroup).get('recruiterNetworkJobs').patchValue(true);
    //       ((this.jobFilterForm.get('source') as UntypedFormArray).at(0) as UntypedFormGroup).get('freeLancerNetworkJobs').patchValue(true);
    //       ((this.jobFilterForm.get('source') as UntypedFormArray).at(0) as UntypedFormGroup).get('mtaNetworkJobs').patchValue(true);
    //       ((this.jobFilterForm.get('source') as UntypedFormArray).at(0) as UntypedFormGroup).get('teamJobs').patchValue(true);
    //       ((this.jobFilterForm.get('source') as UntypedFormArray).at(0) as UntypedFormGroup).get('all').patchValue(true);

    //       this.jobSource.push("myJobs");
    //       this.jobSource.push("recruiterNetworkJobs");
    //       if (!this.FeaSugg) {
    //         this.jobSource.push("featured");
    //         this.jobSource.push("suggestedJobs");
    //       }
    //       this.jobSource.push("freeLancerNetworkJobs");
    //       this.jobSource.push("mtaNetworkJobs");
    //       this.jobSource.push("teamJobs");
    //       this.jobSource = [...new Set(this.jobSource)]
    //     }
    //   }

    //   this.activeStatus = null;
    // }
    // else if (!this.activeStatus) {

    //   if (this.owner && this.isMyJobsShowedOnLoad) {
    //     if (((this.jobFilterForm.get('source') as UntypedFormArray).at(0) as UntypedFormGroup).get('myJobs').value == false &&
    //       ((this.jobFilterForm.get('source') as UntypedFormArray).at(0) as UntypedFormGroup).get('marketPlaceJobs').value == false &&
    //       ((this.jobFilterForm.get('source') as UntypedFormArray).at(0) as UntypedFormGroup).get('recruiterNetworkJobs').value == false &&
    //       ((this.jobFilterForm.get('source') as UntypedFormArray).at(0) as UntypedFormGroup).get('freeLancerNetworkJobs').value == false &&
    //       ((this.jobFilterForm.get('source') as UntypedFormArray).at(0) as UntypedFormGroup).get('mtaNetworkJobs').value == false &&
    //       ((this.jobFilterForm.get('source') as UntypedFormArray).at(0) as UntypedFormGroup).get('teamJobs').value == false) {

    //       ((this.jobFilterForm.get('source') as UntypedFormArray).at(0) as UntypedFormGroup).get('myJobs').patchValue(true);

    //       this.jobSource.push("myJobs");

    //       this.jobSource = [...new Set(this.jobSource)]
    //     }
    //   } else if (!this.isMyJobsShowedOnLoad) {
    //     if (((this.jobFilterForm.get('source') as UntypedFormArray).at(0) as UntypedFormGroup).get('myJobs').value == false &&
    //       ((this.jobFilterForm.get('source') as UntypedFormArray).at(0) as UntypedFormGroup).get('marketPlaceJobs').value == false &&
    //       ((this.jobFilterForm.get('source') as UntypedFormArray).at(0) as UntypedFormGroup).get('recruiterNetworkJobs').value == false &&
    //       ((this.jobFilterForm.get('source') as UntypedFormArray).at(0) as UntypedFormGroup).get('freeLancerNetworkJobs').value == false &&
    //       ((this.jobFilterForm.get('source') as UntypedFormArray).at(0) as UntypedFormGroup).get('mtaNetworkJobs').value == false &&
    //       ((this.jobFilterForm.get('source') as UntypedFormArray).at(0) as UntypedFormGroup).get('teamJobs').value == false) {

    //       ((this.jobFilterForm.get('source') as UntypedFormArray).at(0) as UntypedFormGroup).get('marketPlaceJobs').patchValue(true);
    //       this.jobSource.push("marketPlaceJobs");
    //       this.jobSource = [...new Set(this.jobSource)]
    //     }
    //   }

    //   this.activeStatus = null;
    // }
    this.updateFunction();
  }
  workModeChange(checked, label) {
    if (label === 'All') {

      if (checked) {
        this.workModeCheckboxes.forEach(item => item.selected = true);
      }
      else if (!checked) {
        this.workModeCheckboxes.forEach(item => item.selected = false);
      }
    }
    else if (label != 'All') {

      this.workModeCheckboxes.forEach(item => {
        if (item.label === label) {
          item.selected = checked;
        }
      });

      const isAllchecked = this.workModeCheckboxes.filter(val => val.label != 'All').every(item => item.selected === true);
      this.workModeCheckboxes[0].selected = isAllchecked;

    }
    this.updateFunction();
  }
  FeaSugg: boolean = false;
  JobSeekerRole = ["all", "marketPlaceJobs", "memberNetworksJobs"];
  async jobSoucecheck(event, lable, param?: any) {

    this.response = []
    this.stopscrollFlag = false
    this.data1.searchAfterKey = null;
    if (event.target.checked == true && this.userType != GigsumoConstants.JOB_SEEKER) {
      for (let key of this.keyarrayjobsouces) {
        if (lable === 'all' && key != 'all') {
          if (key === 'myJobs' && this.owner && !this.jobSource.includes(key)) {
            this.jobSource.push(key);
            this.jobSource = [...new Set(this.jobSource)];
           } else if (key == 'teamJobs' && !this.jobSource.includes(key)) {
            this.jobSource.push(key);
            this.jobSource = [...new Set(this.jobSource)]

          } else if (key == 'recruiterNetworkJobs' && !this.jobSource.includes(key)) {
            this.jobSource.push(key);
            this.jobSource = [...new Set(this.jobSource)]

          } else if (key == 'freeLancerNetworkJobs' && !this.jobSource.includes(key)) {
            this.jobSource.push(key);
            this.jobSource = [...new Set(this.jobSource)]

          } else if (key == 'mtaNetworkJobs' && !this.jobSource.includes(key)) {
            this.jobSource.push(key);
            this.jobSource = [...new Set(this.jobSource)]

          } else if (key == 'featured' && !this.jobSource.includes(key)) {
            this.jobSource.push(key);
            this.jobSource = [...new Set(this.jobSource)]
           } else if (key == 'suggestedJobs' && !this.jobSource.includes(key)) {
            this.jobSource.push(key);
            this.jobSource = [...new Set(this.jobSource)]
           } else if (key == 'marketPlaceJobs' && this.owner && !this.jobSource.includes(key)) {
            // when platform jobs is selected it does not require other sources
            this.jobSource.push(key);
            this.jobSource = [...new Set(this.jobSource)]
           }
        } else {

          if (lable != 'all' && !this.jobSource.includes(lable)) {
            this.jobSource.push(lable);
            this.jobSource = [...new Set(this.jobSource)];
            // this.jobSourcesFormarray.at(0).get(lable).patchValue(true);
          }



          // code to remove platform jobs if filters other than platform job is chosen
          // if (lable !== 'marketPlaceJobs') {
          //   let arr: any = this.jobSource.filter(item => item !== 'marketPlaceJobs');
          //   this.jobSource = arr;
          //   this.jobSource = [...new Set(this.jobSource)];
          //   ((this.jobFilterForm.get('source') as FormArray).at(0) as FormGroup).get('marketPlaceJobs').patchValue(false);
          // }
          // else if (lable === 'marketPlaceJobs') {
          //   let arr: any = this.jobSource.filter(item => item === 'marketPlaceJobs');
          //   this.jobSource = arr;
          //   this.jobSource = [...new Set(this.jobSource)];
          //   ((this.jobFilterForm.get('source') as FormArray).at(0) as FormGroup).patchValue({
          //     marketPlaceJobs: true,
          //     myJobs: false,
          //     all: false,
          //     recruiterNetworkJobs: false,
          //     freeLancerNetworkJobs: false,
          //     mtaNetworkJobs: false,
          //     teamJobs: false,
          //     featured: false,
          //     suggestedJobs: false
          //   });
          // }
        }
      }

      if(this.checkIfAllChecked()){
        this.jobSourcesFormarray.at(0).get('all').patchValue(true);
      }
    }
    else if (!event.target.checked && this.userType != GigsumoConstants.JOB_SEEKER) {
      if (lable != 'all') {
        ((this.jobFilterForm.get('source') as UntypedFormArray).at(0) as UntypedFormGroup).get('all').patchValue(event.target.checked);
      }

      if (lable == 'myJobs') {
        this.response = []
        this.obj.searchAfterKey = null;
        this.data1.searchAfterKey = null;
        this.previousSearchAfterKey = null;
        this.previousSearchAfterKey1 = null;
      }
      if (lable == 'all') {
        for (let key of this.keyarrayjobsouces) {
          if (this.jobSource.includes(key)) {
            this.jobSource.splice(this.jobSource.indexOf(key), 1);
            this.jobSource = [...new Set(this.jobSource)]
          }
        }
      } else {
        if (this.jobSource.includes(lable)) {
          this.jobSource.splice(this.jobSource.indexOf(lable), 1);
        }
      }
    }


    if (this.userType === GigsumoConstants.JOB_SEEKER) {
      const sourceFormArray = (this.jobFilterForm.get('source') as UntypedFormArray).at(0) as UntypedFormGroup;
      const formValues = this.jobFilterForm.get('source').value;

      if (lable === 'all') {
        this.jobSource = [];
        this.JobSeekerRole.forEach(key => {
        sourceFormArray.get(key).patchValue(event.target.checked);
        this.jobSource.push(key);
        });
      } else {
        sourceFormArray.get(lable).patchValue(event.target.checked);
        if (event.target.checked) {
          this.jobSource.push(lable);
          sourceFormArray.get('all').patchValue(formValues[0].marketPlaceJobs && formValues[0].memberNetworksJobs);
        } else {
          this.jobSource.splice(this.jobSource.indexOf(lable), 1);
          sourceFormArray.get('all').patchValue(false);
        }
      }

      this.jobSource = Array.from(new Set(this.jobSource));
    }

    let personalNetworkData = [];

    this.jobSource.forEach(element => {
      this.personalNetworks.forEach(x=>{
          if(x.key === element){
            personalNetworkData.push(x.networkId);
          }
      });
    });

    if (lable === 'all') {
      let isChecked = event.target.checked;

      if (this.userType != GigsumoConstants.JOB_SEEKER) {
        this.jobsouceCheckedAll(isChecked);

        if (isChecked) {
          this.jobSource = [];
          Object.keys((this.jobSourcesFormarray.at(0) as FormGroup).controls).forEach(key => {
            this.jobSource.push(key);
          });
        }
        else {
          this.jobSource = [];
        }
      }

      this.setToDefaulFilter();
      this.setToDefaulFilter("CUSTOMER");
      this.publishedPayload.personalNetworks = isChecked ? this.allPersonalNetworks : [];
      this.publishedPayload.memberNetworkChosen = isChecked;
      this.customerPayload.businessNetworks = isChecked ? this.allBusinessNetwork : [];

      this.getBusinessCustomers();
      this.getPublishedBy();
    }


    if(lable === "memberNetworksJobs"){
      this.setToDefaulFilter('CUSTOMER');
      let isMemberNetworkTrue = this.jobSourcesFormarray.at(0).get(lable).value;
      this.customerPayload.memberNetworkChosen =  isMemberNetworkTrue;
      this.customerPayload.businessList = this.customerPrevSelectedValue.map(x => x.businessId);
      await this.getBusinessCustomers("MEMBER_NETWORK");
    }
    else if(lable === "businessNetwork"){
        this.istempBusinessNetwork = this.jobSourcesFormarray.at(0).get(lable).value;
        this.setToDefaulFilter("CUSTOMER");
        this.customerPayload.businessNetworks = event.target.checked ? this.businessNetworkData.map(x => x.b2bNetworkId) : [];
        this.selectedBusinessNetworks = this.istempBusinessNetwork ? this.customerPayload.businessNetworks : [];
        this.businessNetworkPrevSelectedValue = [];
        this.busienssNetworkCount = 0;
        this.businessNetworkData =  this.tempBusinessNetworks.map(x => {
          x.enabled = false;
          return x;
        });
        this.customerPayload.businessList = this.customerPrevSelectedValue.map(x => x.businessId);
        this.customerPayload.businessNetworkChosen = this.istempBusinessNetwork;
        await this.getBusinessCustomers();
    }
    else if(param === "personalNetworks"){
       this.callPublishedBy(personalNetworkData);
       this.publishedPayload.users = this.publishedByPrevSelectedValue.map(x => x.userId);
       await this.getPublishedBy();
    }

    const isMyJobsChecked : boolean  = this.jobSourcesFormarray.at(0) != undefined ? this.jobSourcesFormarray.at(0).get('myJobs').value : false;
    this.statusCheckboxes = updateStatusCheckBox(this.statusCheckboxes , this.owner ? isMyJobsChecked : false);
    // this.statusCount = this.statusCheckboxes.filter(x => !x.disable).length;
    // Refresh the badge from the live form state (the parent doesn't reassign
    // filterChanges on a horizontal toggle, so ngOnChanges won't do it for us).
    const liveSource = this.jobSourcesFormarray.at(0) as UntypedFormGroup;
    this.sourceCount = this.computeSourceCount(liveSource ? liveSource.getRawValue() : null);
    this.updateFunction();

  }




  // Only the checkboxes the template actually renders — mirrors the *ngIf's in
  // the Source dropdown. Commented-out / hidden controls (recruiterNetworkJobs,
  // featured, myEmployees, …) can never be ticked one by one, so they mustn't
  // block the auto-"All".
  private visibleSourceKeys(): string[] {
    const keys = ['marketPlaceJobs', 'memberNetworksJobs'];
    if (this.owner) keys.push('myJobs');
    if (!this.filterApplied) {
      keys.push(...(this.personalNetworks || []).map(x => x.key));
      if (this.userType != GigsumoConstants.JOB_SEEKER) keys.push('teamJobs');
    }
    if (this.userType != GigsumoConstants.JOB_SEEKER && this.businessNetworkData?.length > 0) keys.push('businessNetwork');
    if (this.userType != GigsumoConstants.JOB_SEEKER && this.memberShipType !== 'Free') keys.push('eligibleSubContractJobs');
    return keys;
  }

  checkIfAllChecked() {
    const group = this.jobSourcesFormarray.at(0) as UntypedFormGroup;
    if (!group) return false;
    return this.visibleSourceKeys().every(key => group.get(key)?.value === true);
  }

  callPublishedBy(data){
    let isMemberNetworkTrue = this.jobSourcesFormarray.at(0).get('memberNetworksJobs').value;
    this.publishedPayload.memberNetworkChosen =  isMemberNetworkTrue;
    this.publishedPayload.personalNetworks = data;
    this.setToDefaulFilter();
  }

  get allBusinessNetwork() {
    return this.businessNetworkData ? this.businessNetworkData.map(x => x.b2bNetworkId) : [];
  }

  get allPersonalNetworks(){
    return this.personalNetworks ? this.personalNetworks.map(x => x.networkId) : [];
  }


  setToDefaulFilter(d = "Published"){
    if(d === "Published"){

      this.publishedPayload.searchAfterKey = null;
      this.publishedByStopScroll = false;
      this.publishedByPrevSearchAfterKey = null;
      this.publishedByList.next([]);
    }
    else{
      this.customerPayload.searchAfterKey = null;
      this.customersStopScroll = false;
      this.customersPrevSearchAfterKey = null;
      this.customersList.next([]);
    }
  }

  publishedByList = new BehaviorSubject<any[]>([]);
  async getPublishedBy() {

    try {
      this.isLoading = true;
      let data = await firstValueFrom(this.apiService.create("business/findNetworkConnections", this.publishedPayload))
      this.gigsumoService.updatePublishedBy(this, data);
      this.isLoading = false;
    } catch (error) {
        this.isLoading = false;
    }
  }

  customersList = new BehaviorSubject<any[]>([]);
  async getBusinessCustomers(from : string = "BUSINESS-NETWORK") {

    if((this.membershipType == "Growth" || this.membershipType == "Starter"||this.membershipType == "ScaleX") || from === 'MEMBER_NETWORK' ){
      try {
        this.isLoading = true;
        this.customerPayload.businessId = this.businessId;
        let data = await firstValueFrom(this.apiService.create("business/findBusinessCustomers", this.customerPayload));
        this.gigsumoService.updateBusinessCustomers(this , data);
        this.isLoading = false;
        } catch (error) {
          this.isLoading = false;
      }
    }


  }



  onSelectCreatedBy(event, control, param?: any) {
    this.stopscrollFlag = false
    this.response = []
    this.obj.searchAfterKey = null;
    this.data1.searchAfterKey = null;
    this.previousSearchAfterKey = null;
    this.previousSearchAfterKey1 = null;

    // this.createdByypesCheckboxes.forEach(item => {
    //   if (item.control == control) {
    //     item.selected = event.target.checked;
    //   }
    // });

    if (event.target.checked == true) {
      this.ischeckedStatus = true;
      if (control == 'all') {
        const nestedForm = this.jobFilterForm.get('organisationTypeParams') as UntypedFormGroup;
        nestedForm.patchValue({ owner: true, all: true, systemsIntergrator: true, primeVendor: true, vendorStaffingAgency: true })
        this.createdByCheckAll(event);
      } else {
        const nestedForm = this.jobFilterForm.get('organisationTypeParams') as UntypedFormGroup;
        nestedForm.get(control).patchValue(true)
        // if (this.createdByypesCheckboxes[0].control == control) {
        //   this.createdByypesCheckboxes[0].selected = true;
        // }
      }
    }
    if (event.target.checked == false) {
      if (control == 'all') {
        this.createdByCheckAll(event);
        const nestedForm = this.jobFilterForm.get('organisationTypeParams') as UntypedFormGroup;
        nestedForm.patchValue({ owner: false, all: false, systemsIntergrator: false, primeVendor: false, vendorStaffingAgency: false });
      } else {
        // if (control == this.createdByypesCheckboxes[0].control) {
        //   this.createdByypesCheckboxes[0].selected = false;
        // }
        const nestedForm = this.jobFilterForm.get('organisationTypeParams') as UntypedFormGroup;
        nestedForm.get(control).patchValue(false);
        nestedForm.get('all').patchValue(false);
      }
    }
    this.updateFunction();
  }

  onExperienceValueChange(content : any) {
    if (content === GigsumoConstants.EXPERIENCE_JUNIOR) {
      this.jobFilterForm.patchValue({ experienceFrom: 1, experienceTo: 3 });
    } else if (content === GigsumoConstants.EXPERIENCE_MID_LEVEL) {
      this.jobFilterForm.patchValue({ experienceFrom: 4, experienceTo: 6 });
    } else if (content === GigsumoConstants.EXPERIENCE_SENIOR) {
      this.jobFilterForm.patchValue({ experienceFrom: 6, experienceTo: 10 });
    } else if (content === GigsumoConstants.EXPERIENCE_ARCHITECT) {
      this.jobFilterForm.patchValue({ experienceFrom: 10, experienceTo: 20 });
    } else {
      this.jobFilterForm.patchValue({ experienceFrom: null, experienceTo: null });
    }
    this.updateFunction();
  }

  jobsouceCheckedAll(checked) {
    Object.keys((this.jobSourcesFormarray.at(0) as FormGroup).controls).forEach(key=>{
      ((this.jobFilterForm.get('source') as UntypedFormArray).at(0) as UntypedFormGroup).get(key).patchValue(checked);
    });
  }


  jobSourceItems: Array<string> = ["Jobs From Platform", "All", "My Jobs", "Recruiter Network",
    "Freelancer Network", "MTA Network", "Workspace Jobs", "Featured Jobs", "Marketplace Jobs"]

  getSelected(content: string): string {
    if (content === "JOB_SOURCE") {
      const data = this.jobFilterForm.get('source') as UntypedFormArray;
      let datas = [];
      Object.keys((data.at(0) as UntypedFormGroup).controls).forEach((ele: any) => {
        if (data.at(0).get(ele).value) {
          datas.push(ele);
        }
      });
      return (datas && datas.length > 0) ? this.pickSmall(datas[0]) : "Job Source";
    }
    else if (content === "STATUS") {
      const data = this.statusCheckboxes.filter(ele => ele.selected === true)
      return (data && data.length > 0) ? data[0].label : "Status";
    }
    else if (content === "CLIENT_TYPE") {
      const data = this.clientTypeCheckboxes.filter(ele => ele.selected === true);
      return (data && data.length > 0) ? data[0].label : "Client Type";
    }
    else if (content === "JOB_ENGAGEMENT_TYPES") {
      const data = this.jobclasscificationCheckboxes.filter(ele => ele.selected === true)
      return (data && data.length > 0) ? data[0].label : "Engagement Type";
    } else if (content == "POSTED_DAY") {
      return this.jobFilterForm.get('postedDayRange').value;
    } else if (content == "CREATED_BY_TYPES") {
      // const data = this.createdByypesCheckboxes.filter(ele => ele.selected === true)
      // return (data && data.length > 0) ? data[0].label : "Posted By";
    } else if (content == "EXPERIENCE_RANGE") {
      return this.jobFilterForm.get('experienceType').value;
    }
    return null;
  }


  pickSmall(val: string): string {
    let jobSourceItems: Array<string> = ["Jobs From Platform", "All", "My Jobs", "Recruiter Network",
      "Freelancer Network", "MTA Network", "Workspace Jobs", "Featured Jobs", "Marketplace Jobs"];

    return jobSourceItems.find(x => {
      if (val === "marketPlaceJobs") {
        val = "Jobs From Platform".toLowerCase().replace(/\s/g, '');
      }
      else if (x === "Freelancer Network") {
        x = "Freelancer Network Jobs".toLowerCase().replace(/\s/g, '');
      }
      else if (x === "MTA Network") {
        x = "MTA Network Jobs".toLowerCase().replace(/\s/g, '');
      }
      else if (val === "featured") {
        val = "Featured Jobs".toLowerCase().replace(/\s/g, '');
      }
      else if (x === "suggestedJobs") {
        x = "Marketplace Jobs".toLowerCase().replace(/\s/g, '');
      }
      else if (x === "Recruiter Network") {
        x = "Recruiter Network Jobs".toLowerCase().replace(/\s/g, '');
      }

      return x.toLowerCase().replace(/\s/g, '') === (val && val.toLowerCase());
    });
  }

  jobclassficheckbox(event, lable, param?: any) {
    this.stopscrollFlag = false
    this.response = []
    this.obj.searchAfterKey = null;
    this.data1.searchAfterKey = null;
    this.previousSearchAfterKey = null;
    this.previousSearchAfterKey1 = null;
    let allData = [];
    this.jobclasscificationCheckboxes.forEach(item => {
      if (item.label == lable) {
        item.selected = event.target.checked;
      }
      if(item.label!='All'){
        allData.push(item);
      }
    });


    if (event.target.checked == true) {
      this.ischeckedStatus = true;
      if (lable == 'All') {
        for (let key of this.jobclasscificationCheckboxes) {
          if (key.label != 'All' && !this.jobSource.includes(key)) {
            this.jobSource.push(key.label);
            this.jobSource = [...new Set(this.jobSource)]
          }
        }
        this.jobclassifiCheckAll(event);
      } else {
        if (!this.jobSource.includes(lable)) {

          this.jobSource.push(lable);
          this.jobSource = [...new Set(this.jobSource)]
        }

      }

      if(allData.every(x => x.selected === true)){
        this.jobclasscificationCheckboxes[0].selected = true;
      }

    }
    else if (event.target.checked == false) {
      if (lable != 'All') {
        this.jobclasscificationCheckboxes[0].selected = false;
        if (this.jobSource.includes(lable)) {
          this.jobSource.splice(this.jobSource.indexOf(lable), 1);
        }
      }

      if (lable == 'All') {
        for (let key of this.jobclasscificationCheckboxes) {
          if (this.jobSource.includes(key.label) && key.label != 'All') {
            this.jobSource.splice(this.jobSource.indexOf(key.label), 1);
            this.jobSource = [...new Set(this.jobSource)]
          }
        }
        this.jobclassifiCheckAll(event);
      }
    }

    if (this.ischeckedStatus && this.ischeckedStatusAll) {
      event.target.checked = true;
    }

    this.updateFunction();
  }

  workTypecheckboxCheckAll(event) {
    const checked = event.target.checked;
    for (let key of this.keysarrWorks) {
      ((this.jobFilterForm.get('workType') as UntypedFormArray).at(0) as UntypedFormGroup).get(key).patchValue(checked);
    }
  }






  stateListCA: any;
  stateListIN: any;
  stateListAU: any;
  countryList: any = [];
  onChangeCountry(event) {
    this.jobFilterForm.get('state').patchValue(null)
    this.jobFilterForm.get('city').patchValue(null)
    this.jobFilterForm.get('zipCode').patchValue(null)
    this.jobFilterForm.value.country = event;
    this.response = [];
    // this.filterWhenNoneJobSouce();
    if (event == "US") {
    } else if (event == "AU") {
      const countryCode = event;
      this.stateListAU = [];

      this.apiService
        .query("country/getAllStates?countryCode=" + countryCode)
        .subscribe((res) => {
          this.stateListAU = res;
        }, err => {
          this.util.stopLoader();
        });
    } else if (event == "IN") {
      const countryCode = event;
      this.stateListIN = [];
      this.apiService
        .query("country/getAllStates?countryCode=" + countryCode)
        .subscribe((res) => {
          this.stateListIN = res;
        }, err => {
          this.util.stopLoader();
        });
    } else if (event == "CA") {
      const countryCode = event;
      this.stateListCA = [];

      this.apiService
        .query("country/getAllStates?countryCode=" + countryCode)
        .subscribe((res) => {
          this.stateListCA = res;
        }, err => {
          this.util.stopLoader();
        });
    }

  }

  onKeyZip(event: any) {
    let data: any = {};
    data.countryCode = "US";
    data.zipCode = event.target.value;
    data.stateCode = "";
    if (data.zipCode.length === 5) {
      this.apiService.create("country/geodetails", data).subscribe((res) => {
        if (
          res &&
          res != null &&
          res != "" &&
          res.length > 0 &&
          event.target.value != ""
        ) {

          res.forEach((ele) => {
            let cityName = ele.cityName;
            let stateName = ele.stateName;
            this.jobFilterForm.patchValue({
              city: cityName,
              state: stateName,
            });
          });
        }
      }, err => {
        this.util.stopLoader();
      });
    }
  }

  digitKeyOnly(e) {
    var keyCode = e.keyCode == 0 ? e.charCode : e.keyCode;
    if ((keyCode >= 37 && keyCode <= 40) || (keyCode == 8 || keyCode == 9 || keyCode == 13) || (keyCode >= 48 && keyCode <= 57)) {
      return true;
    }
    return false;
  }

  jobclassifiCheckAll(event) {
    const checked = event.target.checked;
    this.jobclasscificationCheckboxes.forEach(item => item.selected = checked);
  }

  createdByCheckAll(event) {
    const checked = event.target.checked;
    // this.createdByypesCheckboxes.forEach(item => item.selected = checked);
  }

  onChangestate(state) {
    this.jobFilterForm.value.state = state;
    this.response = [];
    this.data1.searchAfterKey = null;
    this.jobFilterForm.get('city').patchValue(null)
    this.jobFilterForm.get('zipCode').patchValue(null)
    // this.filterWhenNoneJobSouce();
  }

  onChangecity(city) {
    this.response = [];
    this.jobFilterForm.value.city = city;
    this.data1.searchAfterKey = null;
    this.jobFilterForm.get('zipCode').patchValue(null)
    // this.filterWhenNoneJobSouce();
  }

  onChangezipcode(zipcode) {
    this.response = [];
    this.jobFilterForm.value.zipCode = zipcode;
    this.data1.searchAfterKey = null;
    // this.filterWhenNoneJobSouce()
  }

  yearApplied: boolean = false
  onChangeYear(value) {

    if (value.highValue > 0) {
      this.yearApplied = true
    } else if (value.highValue == 0) {
      this.yearApplied = false
    }
    this.jobFilterForm.value.experienceFrom = value.value
    this.jobFilterForm.value.experienceTo = value.highValue
    // this.filterWhenNoneJobSouce()
    // value.value
  }
  daysApplied: boolean = false
  onChangedays(value, param?: any) {


    if (value.highValue > 0) {
      this.daysApplied = true
    } else if (value.highValue == 0) {
      this.daysApplied = false
    }
    this.jobFilterForm.get('postedFrom').patchValue(value.value);
    this.jobFilterForm.get('postedTo').patchValue(value.highValue)
    // this.filterWhenNoneJobSouce()
    this.updateFunction();
    // value.value
  }

  cancel() {
    // this.router.navigate(["newcandidates"])
  }

  resetFilternew() {
    this.value = 0;
    this.highValue = 0;
    this.value1 = 0;
    this.highValue1 = 0;
    this.jobSource = ['myJobs'];
    this.response = []
    this.obj.searchAfterKey = null;
    this.previousSearchAfterKey = null;
    this.previousSearchAfterKey1 = null;

    if (this.jobFilterForm != undefined) {
      this.jobFilterForm.get('state').patchValue(null)
      this.jobFilterForm.get('country').patchValue(null)
      this.jobFilterForm.get('city').patchValue(null)
      this.jobFilterForm.get('zipCode').patchValue(null)


      this.clientTypeCheckboxes.forEach(item => item.selected = false);
      this.statusCheckboxes.forEach(item => item.selected = false);
      this.jobclasscificationCheckboxes.forEach(item => item.selected = false);

      for (let key of this.keyarrayjobsouces) {
        ((this.jobFilterForm.get('source') as UntypedFormArray).at(0) as UntypedFormGroup).get(key).patchValue(false);
      }

      for (let key of this.keysarrWorks) {
        ((this.jobFilterForm.get('workType') as UntypedFormArray).at(0) as UntypedFormGroup).get(key).patchValue(false);
      }

      if (this.owner && this.isMyJobsShowedOnLoad) {
        ((this.jobFilterForm.get('source') as UntypedFormArray).at(0) as UntypedFormGroup).get('myJobs').patchValue(true);
      } else if (!this.isMyJobsShowedOnLoad) {
        ((this.jobFilterForm.get('source') as UntypedFormArray).at(0) as UntypedFormGroup).get('marketPlaceJobs').patchValue(true);
      }
      // this.response = [];
      this.data1.searchAfterKey = null;
      this.data.searchAfterKey = null;

    }

  }

  createjobFilterForm() {
    this.jobFilterForm = this.formBuilder.group({
      source: this.formBuilder.array([]),
      workMode:[],
      jobClassification: null,
      clientType: null,
      status: null,
      userId: localStorage.getItem('userId'),
      country: null,
      state: null,
      city: null,
      zipCode: null,
      experienceFrom: null,
      experienceTo: null,
      postedFrom: null,
      resetFilter: false,
      postedTo: null,
      postedDayRangeContent: 'Posted (Days)',
      experienceTypeContent: 'Experience (Years)',
      postedDayRange: 'Any (Days)',
      experienceType: 'Any (Years)',
      organisationTypeParamsContent : 'Posted By',
      jobSourceContent: 'Job Source',
      clientTypeContent: 'Client Type',
      engagementTypeContent: 'Engagement Type',
      statusContent: 'Status',
      workTypeContent: 'Work Mode',
      customerContent: 'Customer',
      businessNetworkContent : 'Business Networks',
      publishedByContent: 'Published By',
      organisationTypeParams: this.formBuilder.group({
        all: false,
        owner: false,
        systemsIntergrator: false,
        primeVendor: false,
        vendorStaffingAgency: false
      })
    });


  }



  // get createdByFormArray() {
  //   const formArray = this.jobFilterForm.get('organisationTypeParams') as FormArray;
  //   return formArray;
  // }

  @Output() panelValue = new EventEmitter<any>(null);
  @Output() valuesRetainedForFilters = new EventEmitter<any>(null);
  startFilter() {
    let data: any = {}
    const jobSource = JSON.parse(localStorage.getItem('jobSource'))
    const jobForm = JSON.parse(localStorage.getItem('jobForm'))
    data.jobSource = jobSource;
    data.jobForm = jobForm
    const jsonData = JSON.stringify(data);
    this.panelValue.emit('jobs')
    this.valuesRetainedForFilters.emit(jsonData);
  }

  // get organisationTypeParams(): FormGroup {
  //   return this.jobFilterForm.get('organisationTypeParams') as FormGroup;
  // }

  getCountries() {
    this.countryList = [];
    this.apiService.query("country/getAllCountries").subscribe((res) => {
      if (res != undefined) {
        res.forEach((ele) => {
          this.countryList.push(ele);
        });
      }
    }, err => {
      this.util.stopLoader();
    });
  }

  jobSourcefields(): UntypedFormGroup {
    return this.formBuilder.group({
      all: false,
      marketPlaceJobs: false,
      myJobs: false,
      teamJobs: false,
      recruiterNetworkJobs: false,
      freeLancerNetworkJobs: false,
      mtaNetworkJobs: false,
      featured: false,
      suggestedJobs: false,
      eligibleSubContractJobs: false

    });
  }



  clientTypeCheckedAll(event) {
    const checked = event.target.checked;
    this.clientTypeCheckboxes.forEach(item => item.selected = checked);

  }

  jobsoucefilterFrom(d) {
    this.jobSourcesFormarray.push(this.jobService.jobSourcefields(d));
    this.jobFilterForm.patchValue(this.filterFormData);

    if(this.isDefaultNetwork){
      this.jobSource.push(this.selectedNetworkId);
       this.updateFunction("VERTICAL");
    }
    else if(this.jobSourcesFormarray.at(0)!=undefined && this.selectedNetworkId){
      this.jobSourcesFormarray.at(0).get(this.selectedNetworkId).patchValue(true);
      const keyValuePairs: Record<string, any> = this.jobSourcesFormarray.getRawValue()[0];
      const keyCounts = Object.values(keyValuePairs).reduce((count, value) => {
        return count + (value ? 1 : 0);
      }, 0);
      this.sourceCount = keyCounts;
      this.jobSource.push(this.selectedNetworkId);
      this.updateFunction("VERTICAL");
    }
  }


  statusCheckAll(event) {
    const checked = event.target.checked;
    this.statusCheckboxes.forEach(item => item.selected = checked);
  }

  removeEntity(value, index) {
    if (this.filterApplied != true) {
      this.jobSource.splice(index, 1);
      if (this.keyarrayjobsouces.includes(value)) {
        ((this.jobFilterForm.get('source') as UntypedFormArray).at(0) as UntypedFormGroup).get('all').patchValue(false);
        ((this.jobFilterForm.get('source') as UntypedFormArray).at(0) as UntypedFormGroup).get(value).patchValue(false);
      }
      if (this.keysarrWorks.includes(value)) {
        ((this.jobFilterForm.get('workType') as UntypedFormArray).at(0) as UntypedFormGroup).get('all').patchValue(false);
        ((this.jobFilterForm.get('workType') as UntypedFormArray).at(0) as UntypedFormGroup).get(value).patchValue(false);
      }

      this.clientTypeCheckboxes.forEach(element => {
        if (element.selected && element.label == value) {
          element.selected = false;
          this.clientTypeCheckboxes[0].selected = false
        }
      });

      this.statusCheckboxes.forEach(element => {
        if (element.selected && element.label == value) {
          element.selected = false;
          this.statusCheckboxes[0].selected = false
        }
      });

      this.jobclasscificationCheckboxes.forEach(element => {
        if (element.selected && element.label == value) {
          element.selected = false;
          this.jobclasscificationCheckboxes[0].selected = false
        }
      });

      if (value == 'myJobs') {
        // this.response = []
        this.obj.searchAfterKey = null;
        this.data1.searchAfterKey = null;
        this.previousSearchAfterKey = null;
        this.previousSearchAfterKey1 = null;
      }
    }

    // this.receiveFilterData.unsubscribe();

  }


  onMenuItemClick(event, param?: any): void {
    event.stopPropagation();

    if (param != null) {
      // this.meunTrigger.closeMenu();
    }
  }



  selectedPublishedBy = [];
  selectedCustomers = [];
  selectedBusinessNetworks = [];
  customerPrevSelectedValue = [];
  publishedByPrevSelectedValue = [];
  businessNetworkPrevSelectedValue = [];
  async onSelectChange(data : any[] , content , object?){

    if(data && this.isSelectedField(content)){

      const key =
      content === "selectedCustomers" ?  "businessId" :
      content === "selectedBusinessNetworks" ? "b2bNetworkId" :
      "userId";

      this[content] = data.filter(x => x.enabled === true).map(c => c[key]);

      if(content === "selectedCustomers"){
        this.customerPrevSelectedValue = data.filter(x => x.enabled === true);
        this.customerPayload.businessList = this.selectedCustomers;
        const datas = this.customersList.getValue().sort((x, y) => (x.enabled === y.enabled)? 0 : x.enabled ? -1 : 1);
        this.customersList.next(datas);
      }
      else if(content === "selectedPublishedBy"){
        this.publishedByPrevSelectedValue = data.filter(x => x.enabled === true);
        this.publishedPayload.users = this.selectedPublishedBy;
        const datas = this.publishedByList.getValue().sort((x, y) => (x.enabled === y.enabled)? 0 : x.enabled ? -1 : 1);
        this.publishedByList.next(datas);
      }
      else if(content === "selectedBusinessNetworks"){
        this.selectedBusinessNetworks = this.selectedBusinessNetworks.length === 0 ?
        this.allBusinessNetwork : this.selectedBusinessNetworks;
        this.businessNetworkPrevSelectedValue = data;
        this.customerPayload.businessNetworks = this.selectedBusinessNetworks;
        this.customerPayload.businessList =  object.selectedCustomers;
        this.setToDefaulFilter("CUSTOMER");
        await this.getBusinessCustomers();
       }

      this.updateFunction();
    }
  }

  isSelectedField(c : keyof JobFilterTemplateComponent) : boolean{
    return c === "selectedPublishedBy" || c === "selectedCustomers" || c === "selectedBusinessNetworks";
  }

  onPublishSearch(e){
    this.publishedPayload.searchContent = e;
    this.setToDefaulFilter();
    this.getPublishedBy();
  }

  onPublishScroll(e){
    this.publishedPayload = {
      ...this.publishedPayload,
      searchAfterKey : this.publishedByPrevSearchAfterKey
    }
    this.getPublishedBy();
  }


  onCustomerSearch(e){
    this.customerPayload.searchContent = e;
    this.setToDefaulFilter("CUSTOMER");
    this.getBusinessCustomers();
  }

  onCustomerScroll(e){
    this.customerPayload = {
      ...this.customerPayload,
      searchAfterKey : this.customersPrevSearchAfterKey
    }
    this.getBusinessCustomers();
  }


}
